import { render } from "./CekAntrianView.html?vue&type=template&id=18f5d6c6&ts=true&external"
import script from "./CekAntrianView.ts?vue&type=script&lang=ts&external"
export * from "./CekAntrianView.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__